// src/hooks/useEditJobModal.js
import {useCallback, useState} from 'react';

/**
 * Hook to manage Edit Job modal state.
 * @returns {Object} {
 *   editJobModalOpen,
 *   jobToEdit,
 *   openEditJobModal,
 *   closeEditJobModal
 * }
 */
export const useEditJobModal = () => {
  const [editJobModalOpen, setEditJobModalOpen] = useState(false);
  const [jobToEdit, setJobToEdit] = useState(null);

  const openEditJobModal = useCallback((job) => {
    setJobToEdit(job);
    setEditJobModalOpen(true);
  }, []);

  const closeEditJobModal = useCallback(() => {
    setEditJobModalOpen(false);
    setJobToEdit(null);
  }, []);

  return {
    editJobModalOpen,
    jobToEdit,
    openEditJobModal,
    closeEditJobModal,
  };
};